<template>
  <div class="col-12 text-center mt-5 mb-5">
    <form ref="form" action="/suche" method="post" id="vue-paginate" v-on:submit.prevent="submit">
      <input name="searchObj" id="searchObj" type="hidden" v-model="searchObjectAsString"/>
      <input type="hidden"
             name="tx_mediathek_search[action]"
             value="paginate"/>
      <input type="hidden"
             name="tx_mediathek_search[search][needle]"
             v-model="searchObj.Needle"/>
      <input type="hidden"
             name="tx_mediathek_search[search][combinedRegion]"
             v-model="searchObj.combinedRegion"/>
      <input type="hidden"
             name="tx_mediathek_search[search][searchTags]"
             v-model="searchObjectJoinedTags"/>
      <input type="hidden"
             name="tx_mediathek_search[search][type]"
             v-model="searchObjectJoinedTypes"/>
      <input type="hidden"
             name="tx_mediathek_search[search][limit]"
             v-model="searchObj.Limit"/>
      <input type="hidden"
             name="tx_mediathek_search[search][currentPage]"
             v-model="currentpage"/>
      <button v-if="isvisible" class="btn btn-success w-auto"
              :disabled="isloading ? true : false"
              type="submit">Weitere Ergebnisse anzeigen
      </button>
    </form>
  </div>
</template>

<script>
import SearchObject from "./SearchObject";

import axios from 'redaxios/dist/redaxios';

export default {
  name: 'MoreResults',
  data: () => {
    return {
      isvisible: true,
      isloading: false,
      currentpage: 0,
      pagecount: 0,
      searchObj: new SearchObject()
    }
  },
  computed: {
    searchObjectAsString () {
      return this.searchObj.toString();
    },
    searchObjectJoinedTags () {
      return this.searchObj.SearchTags.join(',');
    },
    searchObjectJoinedTypes () {
      return this.searchObj.Type.join(',');
    }
  },
  created() {
    this.currentpage = parseInt(this.$attrs.currentpage);
    this.pagecount = parseInt(this.$attrs.pagecount);
  },
  methods: {
    submit: function () {
      this.currentpage += 1;
      this.isloading = true;
      setTimeout(() => {
        let formData, search;
        formData = new FormData(this.$refs.form);
        search = new URLSearchParams(formData);
        this.fetchElements('/suche?' + search.toString());
      }, 250);
    },
    async fetchElements(uri) {
      await axios.get(uri)
          .then(response => {
            if (response.status === 200)
              this.appendItems(response.data);
          })
          .catch(error => {
            console.log('🌞',error);
            this.isvisible = false;
          });
    },
    appendItems(html) {
      let items = new DOMParser().parseFromString(html, 'text/html');
      for (let i = 0; i < items.body.childNodes.length; i++) {
        document.getElementById('results').append(items.body.childNodes[i]);
      }
      this.isloading = false;
      SK.vue.$forceUpdate();
      if (this.currentpage >= this.pagecount)
        this.isvisible = false;
    }
  }
}
</script>

<style lang="scss">
</style>